import * as Yup from 'yup';

export const petValidationSchema = Yup.object().shape({
  nome: Yup.string()
    .required('Nome é obrigatório')
    .min(2, 'Nome deve ter no mínimo 2 caracteres')
    .max(50, 'Nome deve ter no máximo 50 caracteres'),
  
  tipo: Yup.string()
    .required('Tipo é obrigatório')
    .oneOf(['cachorro', 'gato', 'ave', 'peixe', 'outro'], 'Tipo inválido'),
  
  raca: Yup.string()
    .required('Raça é obrigatória')
    .min(2, 'Raça deve ter no mínimo 2 caracteres')
    .max(50, 'Raça deve ter no máximo 50 caracteres'),
  
  idade: Yup.number()
    .min(0, 'Idade não pode ser negativa')
    .max(50, 'Idade não pode ser maior que 50 anos')
    .required('Idade é obrigatória'),
  
  peso: Yup.number()
    .min(0, 'Peso não pode ser negativo')
    .max(200, 'Peso não pode ser maior que 200kg')
    .required('Peso é obrigatório'),
  
  cor: Yup.string()
    .required('Cor é obrigatória')
    .min(2, 'Cor deve ter no mínimo 2 caracteres')
    .max(30, 'Cor deve ter no máximo 30 caracteres'),
  
  observacoes: Yup.string()
    .max(500, 'Observações deve ter no máximo 500 caracteres')
    .optional(),
  
  foto: Yup.array()
    .max(1, 'Apenas uma foto é permitida')
    .optional(),
}); 